import { SaleOrderLinesService } from '@/services/sale.order.lines.service'
import { SaleAdvancePaymentService } from '@/services/sale.advance.payment.inv.service'
import { AccountMoveLineService } from '@/services/account.move.line.service'
import { SaleOrdersService } from '@/services/sale.orders.service'
import { AccountMoveService } from '@/services/account.move.service'
import { EnrollmentsService } from '@/services/enrollments.service'
import moment from 'moment'

export default {
  data () {
    return {
      names: [
        'Cuota de inscripción de ',
        'Cuota de Marzo de ',
        'Cuota de Abril de ',
        'Cuota de Mayo de ',
        'Cuota de Junio de ',
        'Cuota de Julio de ',
        'Cuota de Agosto de ',
        'Cuota de Septiembre de ',
        'Cuota de Octubre de ',
        'Cuota de Noviembre de ',
        'Cuota de Diciembre de '
      ],
      advPayments: {
        advEnrollment: {
          advance_payment_method: 'fixed',
          fixed_amount: '0',
          amount: '0',
          display_name: 'Cuota de inscripción de '
        },
        advMarch: {
          advance_payment_method: 'fixed',
          fixed_amount: '0',
          amount: '0',
          display_name: 'Cuota de Marzo de '
        },
        advMonthly: {
          advance_payment_method: 'fixed',
          fixed_amount: '0',
          amount: '0',
          display_name: 'Cuota Mensual de '
        },
        advDecember: {
          advance_payment_method: 'fixed',
          fixed_amount: '0',
          amount: '0',
          display_name: 'Cuota de Diciembre de '
        }
      },
      dueDates: {
        inscripción: '02-28',
        Marzo: '03-10',
        Abril: '04-10',
        Mayo: '05-10',
        Junio: '06-10',
        Julio: '07-10',
        Agosto: '08-10',
        Septiembre: '09-10',
        Octubre: '10-10',
        Noviembre: '11-10',
        Diciembre: '12-10'
      },
      months: ['Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre']
    }
  },
  methods: {
    async actualizarCuentaCorriente () {
      console.log('actualizo nuevos valores de  venta de la inscripcion')
      await this._actualicarMontosInscripcion()
      console.log('elimino facturas borrador')
      await this._eliminarFacturasBorrador()
      await this._createDraftInvoices()
      /* const so = await SaleOrdersService.read([this.SO.id])
      console.log('XXXXXXXXXXXXXXXX', so)
      await this.onDemandCreateDraftInvoices(so[0])
      const totals = await this.getTotals(so[0])
      for (let i = 0; i < this.tableItems.length; i++) {
        const price_unit = totals.totals.enrollment + totals.totals.march + (totals.totals.monthly * 8) + totals.totals.december
        await SaleOrderLinesService.update(this.tableItems[i].id, { price_unit: price_unit })
      } */
    },
    async _createDraftInvoices () {
      const so = await SaleOrdersService.read([this.SO.id])
      const data = await this.getTotals(so[0])
      console.log(data)
      const totals = data.totals
      const students = data.students
      await this.createAdvPayments(totals, students)
      let sol = []
      this.saleOrder = await this.getSo(this.family.id)
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      console.log(sol, 'SOL')
      await this.updateSolNames(sol, students)
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      await this.updateInvoiceNames(sol)
      await this.updateListado()
      await this._updateDueDates()
      await this.updateListado()
      
      // console.log(this.SO)
      console.log('end')
    },
    async _updateDueDates () {
      const concepts = Object.keys(this.dueDates)
      for (let i = 0; i < this.SO.invoice_ids.length; i++) {
        const item = this.SO.invoice_ids[i]
        if (item.state !== 'posted' && item.state !== 'cancel') {
          console.log(item)
          for (let j = 0; j < concepts.length; j++) {
            if (item.invoice_line_ids[0].name.indexOf(concepts[j]) !== -1) {
              console.log(moment().format('yyyy-') + this.dueDates[concepts[j]])
              await AccountMoveService.update(item.id, { invoice_date_due: moment().format('yyyy-') + this.dueDates[concepts[j]] })
              console.log('XXXXXXXXXXXXXXXXX')
            }
          }
        }
      }
    },
    async eliminarInscripcion () {
      this.isLoading = true
      for (let i = 0; i < this.sol.length; i++) {
        if (!this.sol[i].is_downpayment) {
          if (this.item.x_sale_order_line_id[0] === this.sol[i].id) {
            await SaleOrderLinesService.update(this.sol[i].id, { product_uom_qty: 0 })
          } else {
            await SaleOrderLinesService.update(this.sol[i].id, {
              x_enrollment_fee: this.sol[i].x_enrollment_fee,
              x_march_fee: this.sol[i].x_march_fee,
              x_monthly_fee: this.sol[i].x_monthly_fee,
              x_december_fee: this.sol[i].x_december_fee
            })
          }
        }
      }
      for (let i = 0; i < this.sol.length; i++) {
        if (this.sol[i].is_downpayment && (this.sol[i].invoice_status === 'to invoice')) {
          const accountMoveLine = await AccountMoveLineService.read([this.sol[i].invoice_lines[0]], [])
          const accountMove = await AccountMoveService.read([accountMoveLine[0].move_id[0]], [])
          
          if (accountMove[0].state !== 'posted') {
            await AccountMoveService.delete(accountMove[0].id)
          }
        }
      }
      if (this.saleOrderItems.length > 1) {
        const so = await SaleOrdersService.read([this.so[0].id])
        await this.onDemandCreateDraftInvoices(so[0])
      }
      await EnrollmentsService.update(this.item.id, { x_status: 'canceled' })
      this.isLoading = false
      this.$bvModal.hide('modal-borrar-inscripcion')
    },
    async getSo (famId) {
      const so = await SaleOrdersService.read([this.saleOrder.id])
      return so[0]
    },
    async getDraftSo (famId) {
      var draftSo = await SaleOrdersService.search({ state: 'draft', partner_id: famId })

      if (draftSo[0] === undefined) {
        await SaleOrdersService.create({ state: 'draft', partner_id: famId })
        draftSo = await SaleOrdersService.search({ state: 'draft', partner_id: famId })
      }

      const SO = await SaleOrdersService.read([draftSo[0]])
      return SO[0]
    },
    async _actualicarMontosInscripcion () {
      for (let i = 0; i < this.tableItems.length; i++) {
        const item = {
          x_enrollment_fee: this.tableItems[i].x_enrollment_fee,
          x_march_fee: this.tableItems[i].x_march_fee,
          x_monthly_fee: this.tableItems[i].x_monthly_fee,
          x_december_fee: this.tableItems[i].x_december_fee
        }
        await SaleOrderLinesService.update(this.tableItems[i].id, item)
        console.log(await EnrollmentsService.list({ x_sale_order_line_id: this.SO.order_line[i].id }))
      }
    },
    async _eliminarFacturasBorrador () {
      const toDeleteInvoices = []
      // const enrollments = []
      const SO = this.SO
      console.log('por cada order line')
      for (let i = 0; i < SO.order_line.length; i++) {
        if (this.SO.order_line[i].is_downpayment && (SO.order_line[i].invoice_status === 'to invoice')) {
          console.log('es donw Payment y esta en estado to invoice', SO.order_line[i])
          toDeleteInvoices.push(new Promise((resolve, reject) => {
            console.log('Inicio Promesa de eliminar ', SO.order_line[i].id)
            AccountMoveLineService.read([SO.order_line[i].invoice_lines[0]], [])
              .then(async function (accountMoveLine) {
                AccountMoveService.read([accountMoveLine[0].move_id[0]], [])
                  .then(async function (accountMove) {
                    if ((accountMove[0].state !== 'posted') && (accountMove[0].state !== 'canceled')) {
                      // const enrollments = []
                      // enrollments.push((await EnrollmentsService.list({ x_invoice_id: accountMove[0].id }))[0])
                      await AccountMoveService.delete(accountMove[0].id).then(function () {
                        resolve('ok')
                      })
                    } else {
                      resolve('posted')
                    }
                  })
              })
          }))
        }
      }
      await Promise.all(toDeleteInvoices)
    },
    
    async getTotals (so) {
      const items = await SaleOrderLinesService.list({ order_id: so.id, is_downpayment: false })
      this.saleOrder = so
      const totals = { enrollment: 0, march: 0, monthly: 0, december: 0, total: 0 }
      let students = ''
      console.log(items)
      for (let j = 0; j < items.length; j++) {
        totals.enrollment += items[j].x_enrollment_fee
        totals.march += items[j].x_march_fee
        totals.monthly += items[j].x_monthly_fee
        totals.december += items[j].x_december_fee
        totals.total += totals.enrollment + totals.march + (totals.monthly * this.months.length) + totals.december
        if (students.length === 0) {
          students += ' ' + items[j].x_student_id[1] + ' en ' + items[j].product_id[1]
        } else {
          students += ' y ' + items[j].x_student_id[1] + ' en ' + items[j].product_id[1]
        }
      }
      if (totals.enrollment === 0) { totals.enrollment = 1 }
      if (totals.march === 0) { totals.march = 1 }
      if (totals.monthly === 0) { totals.monthly = 1 }
      if (totals.december === 0) { totals.december = 1 }
      return { students: students, totals: totals }
    },
    async onDemandCreateDraftInvoices (so) {
      const data = await this.getTotals(so)
      await this.createDraftInvoices(data.totals, data.students)
      this.updateAccountMoves()
    },
    async updateAccountMoves () {
      this.accountMoves = await AccountMoveService.list({ partner_id: this.family.id }, { limit: 0, order: 'id desc' })
    },
    async createDraftInvoices (totals, students) {
      totals.total = totals.enrollment + totals.march + (totals.monthly * 8) + totals.december
      if (totals.enrollment === 0) { totals.enrollment = 1 }
      if (totals.march === 0) { totals.march = 1 }
      if (totals.monthly === 0) { totals.monthly = 1 }
      if (totals.december === 0) { totals.december = 1 }

      await this.createAdvPayments(totals, students)
      let sol = []
      this.saleOrder = await this.getSo(this.family.id)
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      console.log(sol, 'SOL')
      
      await this.updateSolNames(sol, students)
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      await this.updateInvoiceNames(sol)
    },

    async updateInvoiceNames (sol) {
      for (let i = 0; i < sol.length; i++) {
        if (sol[i].is_downpayment) {
          console.log(sol[i])
          console.log(await AccountMoveLineService.update(sol[i].invoice_lines, { name: sol[i].name }))
          // invoicePromises.push()
        }
      }
    },

    async updateSolNames (sol, students) {
      let index = 0
      
      const names = [
        'Cuota de inscripción de ' + students,
        'Cuota de Marzo de ' + students,
        'Cuota de Abril de ' + students,
        'Cuota de Mayo de ' + students,
        'Cuota de Junio de ' + students,
        'Cuota de Julio de ' + students,
        'Cuota de Agosto de ' + students,
        'Cuota de Septiembre de ' + students,
        'Cuota de Octubre de ' + students,
        'Cuota de Noviembre de ' + students,
        'Cuota de Diciembre de ' + students
      ]
      const solPromises = []
      for (let i = 0; i < sol.length; i++) {
        if (sol[i].is_downpayment) {
          solPromises.push(SaleOrderLinesService.update([sol[i].id], {
            name: names[index]
          }))
          console.log(index, names[index])
          index++
        }
      }
      await Promise.all(solPromises)
    },
    async createAdvPayments (totals, students) {
      const advPaymentPromises = []
      const context = {
        context: {
          active_id: this.saleOrder.id,
          active_ids: [this.saleOrder.id],
          active_model: 'sales.order'
        }
      }
      
      if ((await SaleOrderLinesService.list([['order_id', '=', this.saleOrder.id], ['name', 'ilike', 'Cuota de inscripción']]))[0] === undefined) {
        this.advPayments.advEnrollment.fixed_amount = totals.enrollment.toString()
        this.advPayments.advEnrollment.display_name += students
        advPaymentPromises.push(new Promise((resolve, reject) => {
          SaleAdvancePaymentService.create(this.advPayments.advEnrollment)
            .then(function (id) {
              SaleAdvancePaymentService.execute('create_invoices', [[id], context]).then(function (result) {
                resolve('ok')
              })
            })
        }))
      }

      if ((await SaleOrderLinesService.list([['order_id', '=', this.saleOrder.id], ['name', 'ilike', 'Cuota de Marzo']]))[0] === undefined) {
        this.advPayments.advMarch.fixed_amount = totals.march.toString()
        this.advPayments.advMarch.display_name += students
        advPaymentPromises.push(new Promise((resolve, reject) => {
          SaleAdvancePaymentService.create(this.advPayments.advMarch)
            .then(function (id) {
              SaleAdvancePaymentService.execute('create_invoices', [[id], context]).then(function (result) {
                resolve('ok')
              })
            })
        }))
      }
      
      this.advPayments.advMonthly.fixed_amount = totals.monthly.toString()

      for (let i = 0; i < this.months.length; i++) {
        if ((await SaleOrderLinesService.list([['order_id', '=', this.saleOrder.id], ['name', 'ilike', 'Cuota de ' + this.months[i]]]))[0] === undefined) {
          this.advPayments.advMonthly.display_name = 'Cuota de ' + this.months[i] + ' de ' + students
          advPaymentPromises.push(new Promise((resolve, reject) => {
            SaleAdvancePaymentService.create(this.advPayments.advMonthly)
              .then(function (id) {
                SaleAdvancePaymentService.execute('create_invoices', [[id], context]).then(function (result) {
                  resolve('ok')
                })
              })
          }))
        }
      }

      if ((await SaleOrderLinesService.list([['order_id', '=', this.saleOrder.id], ['name', 'ilike', 'Cuota de Diciembre']]))[0] === undefined) {
        this.advPayments.advDecember.fixed_amount = totals.december.toString()
        this.advPayments.advDecember.display_name += students
        advPaymentPromises.push(new Promise((resolve, reject) => {
          SaleAdvancePaymentService.create(this.advPayments.advDecember)
            .then(function (id) {
              SaleAdvancePaymentService.execute('create_invoices', [[id], context]).then(function (result) {
                resolve('ok')
              })
            })
        }))
      }

      await Promise.all(advPaymentPromises)
    }
  }
}
